import { match } from 'path-to-regexp';

/**
 * @memberof ux-tread-dotcom-utils
 * @typedef {object} UrlParts
 * @property {string} domain - originating domain of service, defined by Nike API standards and domain driven design guidelines, eg buy
 * @property {string} host - host domain of url  "api.nike.com",
 * @property {string} protocol - protocol identifier eg: http,https,ftp
 * @property {string} queryOrPathParams - remaining parameters in url, query or path based params
 * @property {string} resource - resource being fetched via api call, defined by Nike API standards, eg carts
 * @property {string} version - version of api being used, defined by Nike API standards, eg v2
 */

/**
 * getApiUrlParts takes a full url and returns url parts in an object format
 *
 * @param {string} url - full url used in an api call
 * @example https://api.nike.com/buy/carts/v2/{uuid} -> buy/carts/v2
 *
 * @returns {UrlParts} an object built out of the api url
 */
export default function getApiUrlParts(url) {
  var _match = match(':protocol(http[s]:\\/\\/):host(.*[com|cn])/:domain/:resource/:version(v\\d+):queryOrPathParams(.*)')(url),
    _match$params = _match.params,
    params = _match$params === void 0 ? {} : _match$params;
  return params;
}